import axios from "axios";

// The app configures axios.defaults.baseURL (see src/config/axios.js); all
// backend routes are served under the "/api" prefix (matching existing stores).
//
// Contract (dent-cloud-service, feat/doctor-working-hours-phase-1):
//  - Recurring rules are edited by REPLACE-ALL: POST the doctor's full rule
//    list and the backend wipes + recreates them. Every rule-scope edit
//    ("all" / "this & following" / create / delete-series) is expressed by the
//    frontend recomputing that full list and sending it here.
//  - Per-date changes are "overrides" (type: leave | shift) via upsert/delete.
//  - Reads come from the resolver endpoint, which returns per-day resolved
//    slots + the raw overrides for the range.
const base = "/api";

export default {
  // Resolved per-day schedule + raw overrides for the range.
  // -> { branchMemberId, from, to, days:[{date,slots,overrideMarkers}], totalMinutes, overrides:[...] }
  async getSchedule({ clinicUrl, branchUrl, branchMemberId, from, to }) {
    const url = `${base}/doctorSchedule/${clinicUrl}/${branchUrl}/${branchMemberId}`;
    const res = await axios.get(url, { params: { from, to } });
    return res.data;
  },

  // Batch resolver for ALL doctor members in a branch over a range (no
  // branchMemberId). Used by the month-overview calendar so 30+ doctors load
  // in one request instead of one call per doctor. Override effects are already
  // resolved into each day's `slots`; raw `overrides[]` are intentionally NOT
  // returned here (overview only needs presence). See docs/working-hours-backend-handoff.md.
  // -> { from, to, members:[{ branchMemberId, days:[{date,slots,overrideMarkers}] }] }
  async getBranchSchedule({ clinicUrl, branchUrl, from, to }) {
    const url = `${base}/doctorSchedule/${clinicUrl}/${branchUrl}`;
    const res = await axios.get(url, { params: { from, to } });
    return res.data;
  },

  // Replace-all of a doctor's recurring rules.
  // doctorWorkingHours: [{ rruleStr, startTime, endTime, roomId }]
  async saveRules({ clinicUrl, branchUrl, branchMemberId, doctorWorkingHours }) {
    const url = `${base}/branchMember/doctorWorkingHour/${clinicUrl}/${branchUrl}`;
    const res = await axios.post(url, { branchMemberId, doctorWorkingHours });
    return res.data;
  },

  // Create or update (id present) a single per-date override.
  // override: { id?, overrideDate, type:'leave'|'shift', startTime, endTime, roomId, note }
  async upsertOverride({ clinicUrl, branchUrl, branchMemberId, override }) {
    const url = `${base}/doctorWorkingHourOverride/${clinicUrl}/${branchUrl}/member/${branchMemberId}`;
    const res = await axios.post(url, override);
    return res.data;
  },

  async deleteOverride({ clinicUrl, branchUrl, overrideId }) {
    const url = `${base}/doctorWorkingHourOverride/${clinicUrl}/${branchUrl}/${overrideId}`;
    await axios.delete(url);
  },
};
